import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import defaultStyle from './common.style.js';
import PersistentAlertBox from './persistent-alert-box'

export class ValidationError extends Component {
  render() {
    const {isValid, errors, errorsTitle, getErrorText, css} = this.props;

    var errorList = errors && errors.map( (error, i) => (
      <li role="presentation" key={i} className={css.errorMessage}>
        {getErrorText(error)}
      </li> ));

    var errorDisplay = null;
    if(!isValid) {
      errorDisplay =
      (
        <div className={css.errorWrapper}>
          <span id='title'>{errorsTitle}</span>
            <ul>
              {errorList}
            </ul>
        </div>
      )
    }

    return (
      <div>
        {errorDisplay}
        <PersistentAlertBox>
          <span>{errorsTitle}</span>
          {errorList}
        </PersistentAlertBox>
      </div>
    );
  }
}

ValidationError.defaultProps = {
  errorsTitle: 'The following validation errors occured:',
  getErrorText: (error) => error.errorMessage + ": " + error.context,
}

ValidationError.propTypes = {
  isValid: PropTypes.bool.isRequired,
  errors: PropTypes.array.isRequired,
  errorsTitle: PropTypes.string,
  getErrorText: PropTypes.func,
};

export default styleable(defaultStyle) (ValidationError);
